import * as wagmiChains from 'wagmi/chains';
import { type Chain as WagmiChain } from 'wagmi/chains';
import { type AnyChainflipChainData, type ChainflipChainData } from '.';

export const bitcoinTestnet = {
  id: 'btc-testnet',
  name: 'Bitcoin Testnet',
  addressPlaceholder: '',
  wagmiChain: undefined,
  chainflipId: 'Bitcoin',
} satisfies ChainflipChainData;

export const solanaDevnet = {
  id: 'sol-devnet',
  name: 'Solana Devnet',
  addressPlaceholder: '',
  wagmiChain: undefined,
  chainflipId: 'Solana',
} satisfies ChainflipChainData;

export const sepolia = {
  id: 'evm-11155111',
  name: 'Sepolia',
  addressPlaceholder: '0x...',
  wagmiChain: wagmiChains.sepolia as WagmiChain,
  chainflipId: 'Ethereum',
} satisfies ChainflipChainData;

export const backspinSolana = {
  id: 'sol-backspin',
  name: 'Backspin Solana',
  addressPlaceholder: '',
  wagmiChain: undefined,
  chainflipId: 'Solana',
} satisfies ChainflipChainData;

export const backspinEthereum = {
  id: 'evm-10997',
  name: 'Backspin',
  addressPlaceholder: '0x...',
  wagmiChain: {
    id: 10997,
    name: 'Backspin',
    network: 'backspin-ethereum',
    nativeCurrency: {
      decimals: 18,
      name: 'Backspin Ether',
      symbol: 'bsETH',
    },
    rpcUrls: {
      public: { http: ['https://eth.backspin.chainflip.io/'] },
      default: { http: ['https://eth.backspin.chainflip.io/'] },
    },
    testnet: true,
  } as WagmiChain,
  chainflipId: 'Ethereum',
} satisfies ChainflipChainData;

export const backspinArbitrum = {
  id: 'evm-412346',
  name: 'Backspin Arbitrum',
  addressPlaceholder: '0x...',
  wagmiChain: {
    id: 412346,
    name: 'Backspin Arbitrum',
    network: 'backspin-arbitrum',
    nativeCurrency: {
      decimals: 18,
      name: 'Backspin Arbitrum Ether',
      symbol: 'ArbETH',
    },
    rpcUrls: {
      public: { http: ['https://http.backspin-sequencer.staging/'] },
      default: { http: ['https://http.backspin-sequencer.staging/'] },
    },
    testnet: true,
  } as WagmiChain,
  chainflipId: 'Arbitrum',
} satisfies ChainflipChainData;

export const dotTestnet = {
  id: 'dot-testnet',
  name: 'Polkadot Testnet',
  addressPlaceholder: '1...',
  wagmiChain: undefined,
  chainflipId: 'Polkadot',
} satisfies AnyChainflipChainData;

export const hubTestnet = {
  id: 'hub-testnet',
  name: 'Polkadot Testnet',
  addressPlaceholder: '1...',
  wagmiChain: undefined,
  chainflipId: 'Assethub',
} satisfies ChainflipChainData;

export const arbitrumSepolia = {
  id: 'evm-421614',
  name: 'Arbitrum Sepolia',
  addressPlaceholder: '0x...',
  wagmiChain: wagmiChains.arbitrumSepolia as WagmiChain,
  chainflipId: 'Arbitrum',
} satisfies ChainflipChainData;

export const backspinTron = {
  id: 'evm-4271970548',
  name: 'Backspin Tron',
  addressPlaceholder: 'T...',
  wagmiChain: {
    id: 4271970548,
    name: 'Backspin Tron',
    network: 'backspin-tron',
    nativeCurrency: {
      decimals: 6,
      name: 'Backspin Tron',
      symbol: 'bTRX',
    },
    rpcUrls: {
      public: { http: ['http://chainflip-backspin:8090/'] },
      default: { http: ['http://chainflip-backspin:8090/'] },
    },
    testnet: true,
  } as WagmiChain,
  chainflipId: 'Tron',
} satisfies ChainflipChainData;

export const tronTestnet = {
  id: 'evm-3448148188',
  name: 'Tron Nile Testnet',
  addressPlaceholder: 'T...',
  wagmiChain: wagmiChains.tronNile as WagmiChain,
  chainflipId: 'Tron',
} satisfies ChainflipChainData;

export const bscTestnet = {
  id: 'evm-97',
  name: 'BNB Chain Testnet',
  addressPlaceholder: '0x...',
  wagmiChain: wagmiChains.bscTestnet as WagmiChain,
  chainflipId: 'Bsc',
} satisfies ChainflipChainData;

export const backspinBsc = {
  id: 'evm-343',
  name: 'Backspin BNB Chain',
  addressPlaceholder: '0x...',
  wagmiChain: {
    id: 343,
    name: 'Backspin BSC',
    network: 'backspin-bsc',
    nativeCurrency: {
      decimals: 18,
      name: 'Backspin BNB',
      symbol: 'bBNB',
    },
    rpcUrls: {
      public: { http: ['http://chainflip-backspin:8645/'] },
      default: { http: ['http://chainflip-backspin:8645/'] },
    },
    testnet: true,
  } as WagmiChain,
  chainflipId: 'Bsc',
} satisfies ChainflipChainData;

export default [
  bitcoinTestnet,
  solanaDevnet,
  sepolia,
  backspinEthereum,
  hubTestnet,
  backspinArbitrum,
  arbitrumSepolia,
  backspinSolana,
  backspinTron,
  tronTestnet,
  bscTestnet,
  backspinBsc,
];
